<template>
  <footer class="footer-container">
    <div class="container">
      <div class="row justify-content-center">
        <!-- Contact Info -->
        <div class="col-md-6 text-center">
          <h4>Contact Us</h4>
          <p>
            <strong>📞 Phone:</strong>
            <a href="tel:+14125374839" class="text-primary">
              (412) 537-4839
            </a>
          </p>
          <p>
            <strong>📧 Email:</strong>
            <a href="mailto:HrMaintenancejl@gmail.com" class="text-primary">
              HrMaintenancejl@gmail.com
            </a>
          </p>
        </div>

        <!-- Work Hours -->
        <div class="col-md-6 text-center">
          <h4>Work Hours</h4>
          <ul class="work-hours">
            <li><strong>Monday:</strong> 8:00 AM - 6:00 PM</li>
            <li><strong>Tuesday:</strong> 8:00 AM - 6:00 PM</li>
            <li><strong>Wednesday:</strong> 8:00 AM - 6:00 PM</li>
            <li><strong>Thursday:</strong> 8:00 AM - 6:00 PM</li>
            <li><strong>Friday:</strong> 8:00 AM - 6:00 PM</li>
            <li><strong>Saturday:</strong> <span class="closed">Closed</span></li>
            <li><strong>Sunday:</strong> <span class="closed">Closed</span></li>
          </ul>
        </div>
      </div>

      <!-- Copyright Section -->
      <div class="text-center mt-4">
        <p>&copy; 2020 HR Maintenance and Cleaning LLC. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
};
</script>

<style scoped>
/* ✅ Footer Background (Navy Blue) */
.footer-container {
  background-color: #001f3f !important; /* Navy blue */
  color: white !important; /* White text */
  padding: 40px 0;
  text-align: center;
}

/* Footer Headings */
h4 {
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: bold;
  color: white !important;
}

/* Work Hours Styling */
.work-hours {
  padding-left: 0;
}

.work-hours li {
  list-style-type: none;
  font-size: 16px;
  padding: 5px 0;
  color: white !important;
}

/* ✅ Highlight "Closed" Days */
.closed {
  color: #ffcc00; /* Yellow */
  font-weight: bold;
}

/* ✅ Ensure Full-Width on Mobile */
@media (max-width: 768px) {
  .footer-container {
    text-align: center;
  }
}
</style>
